const instructions = {
    COVER_LETTER_DOCUMENT: [
        "Download and review the Form 2553 Cover Letter.",
        "Print the cover letter.",
        "Manually sign and date the cover letter in the designated areas.",
        "Scan the signed/dated cover letter. <b>Use a scanner, not your phone.</b>",
        "Upload the signed/dated cover letter to your account.",
        "Click “Submit”."
    ],
    OFFICER_DOCUMENT: [
        "Download and review the Form 2553 Signature Page.",
        "Print the signature page.",
        "Manually sign and date the signature page in the designated areas.",
        "Scan the signed/dated signature page. <b>Use a scanner, not your phone.</b>",
        "Upload the signed/dated signature page to your account.",
        "Click “Submit”."
    ],
    SHAREHOLDER_DOCUMENT: [
        "Download and review the Shareholder’s Consent Statement.",
        "Print the statement.",
        "Manually sign and date the statement in the designated areas.",
        "Scan the signed/dated statement.<b>Use a scanner, not your phone.</b>",
        "Upload the signed/dated statement to your account.",
        "Click “Submit”."
    ]
};

export default instructions;